import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { Button, ButtonGroup, ControlLabel, FormGroup, Row } from '@cancercentrum/rcc-bootstrap';
import { useSelector } from 'react-redux';
import ValidationGroup from '../ValidationGroup';
import Validation from '../Validation';
import { HintText } from '../HintText';
import { Explanation } from '../Explanation';
import ReviewerCheckbox from '../../components/ReviewerCheckbox';
import { useI18n } from '../../i18n';
import { useDataActions } from '../../hooks/useDataActions';
import { useClearable } from '../../hooks/useClearable';
import { IncaContext } from '../ScopedIncaContext/IncaContext';
const onReviewerClick = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const BoolButtonGroup = (props)=>{
    const { regvars, labelClassName, wrapperClassName, label, minSelected, maxSelected, labelHelp, labelHelpTitle, labelTooltip, bsStyle, selectedBsStyle = 'info' } = props;
    const dataActions = useDataActions();
    const showReviewerCheckboxes = useSelector((state)=>state?.settings?.showReviewerCheckboxes ?? false);
    const incaCtx = useContext(IncaContext);
    useClearable((row, options)=>regvars.reduce((r, rv)=>r.clearRegvarValue(rv.$rcc.shortname, options), row));
    const isDisabled = ()=>{
        return props.disabled !== undefined ? props.disabled : !!incaCtx?.form.isReadOnly;
    };
    const onClick = (shortname, event)=>{
        event.preventDefault();
        if (!isDisabled()) {
            dataActions.updateRow((x)=>x.setRegvarValue(shortname, !x.getRegvarValue(shortname), {
                    markAsDirty: true
                }));
        }
    };
    const { t } = useI18n();
    const isMinSelectedValid = typeof minSelected === 'boolean' || typeof minSelected === 'number' && regvars.filter((x)=>x.value).length >= minSelected;
    const isMaxSelectedValid = typeof maxSelected === 'boolean' || typeof maxSelected === 'number' && regvars.filter((x)=>x.value).length <= maxSelected;
    const disabled = isDisabled();
    const isDirty = regvars.reduce((dirty, regvar)=>dirty || regvar.$isDirty, false);
    let labelHelpNode = null;
    if (labelHelp) {
        labelHelpNode = /*#__PURE__*/ _jsx(Explanation, {
            title: labelHelpTitle,
            children: labelHelp
        });
    }
    const labelNode = labelTooltip ? /*#__PURE__*/ _jsx(HintText, {
        text: label,
        tooltip: labelTooltip
    }) : label;
    const items = regvars.map((x)=>{
        const btnStyle = x.value ? selectedBsStyle : bsStyle;
        return /*#__PURE__*/ _jsxs(Button, {
            href: "#",
            bsStyle: btnStyle,
            onClick: (e)=>onClick(x.$rcc.shortname, e),
            active: x.value,
            disabled: disabled,
            children: [
                /*#__PURE__*/ _jsx("span", {
                    children: x.$rcc.regvarMetadata.label
                }),
                showReviewerCheckboxes && /*#__PURE__*/ _jsx(ReviewerCheckbox, {
                    regvar: x,
                    className: "multi-bool-group__reviewer-checkbox",
                    onClick: onReviewerClick
                })
            ]
        }, x.$rcc.shortname);
    });
    return /*#__PURE__*/ _jsx("div", {
        className: "bool-button-group",
        children: /*#__PURE__*/ _jsxs(ValidationGroup, {
            children: [
                /*#__PURE__*/ _jsxs(FormGroup, {
                    componentClass: Row,
                    children: [
                        /*#__PURE__*/ _jsxs(ControlLabel, {
                            className: labelClassName,
                            children: [
                                labelNode,
                                " ",
                                labelHelpNode
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: wrapperClassName,
                            children: /*#__PURE__*/ _jsx(ButtonGroup, {
                                children: items
                            })
                        })
                    ]
                }),
                typeof minSelected === 'number' && /*#__PURE__*/ _jsx(Validation, {
                    isValid: isMinSelectedValid,
                    isDefaultDirty: isDirty,
                    children: t('validation.minSelected', minSelected)
                }),
                typeof maxSelected === 'number' && /*#__PURE__*/ _jsx(Validation, {
                    isValid: isMaxSelectedValid,
                    isDefaultDirty: isDirty,
                    children: t('validation.maxSelected', maxSelected)
                })
            ]
        })
    });
};
export default /*#__PURE__*/ memo(BoolButtonGroup);
